<template>
  <div class="warpper" :style="`${hide ? 'height:calc(100vh - 30px)' : ''}`">
    <div id="map-wrapper" class="map-wrapper"></div>
    <div class="tools-bar">
      <p class="select-tabs">
        <span :class="{ dragActive: active === 1 }" class="drag" @click="changeActive(1)" />
        <span :class="{ drawActive: active === 2 }" class="draw" @click="changeActive(2)" />
      </p>
      <el-autocomplete id="suggestId" class="map-input" v-model="address_detail" :fetch-suggestions="querySearchAddress" placeholder="请输入关键字" :trigger-on-focus="false" @select="handleSelectAddress"
        value-key="title" clearable>
        <template slot-scope="{ item }">
          <span class="name">{{ item.title }}</span>
          <span style="font-size: 12px; color: #999; margin-left: 4px">
            {{ getPCD(item.province, item.city, item.district) }}
          </span>
        </template>
      </el-autocomplete>
      <el-popover placement="bottom-start" width="520" v-model="visible" popper-class="custom-city-popper" :visible-arrow="false">
        <div class="city-list-container">
          <div class="ct_title">
            城市列表<i class="el-icon-close" @click="visible = false" />
          </div>
          <div class="city_content_top">
            <p class="cur_city_info">当前城市：{{ currentCity }}</p>
            <el-autocomplete v-model="cityName" :fetch-suggestions="querySearchCity" :trigger-on-focus="false" placeholder="请输入城市名称" prefix-icon="el-icon-search" size="small" value-key="fullname"
              clearable @select="(item) => (cityItem = item)" @clear="cityItem = null" />
            <el-button size="small" @click="handleSearchCity">搜索</el-button>
          </div>
          <div class="city_content_medium">
            <div class="sel_city_hotcity">
              <a v-for="(item, index) in hostCityList" :key="index" class="city-a" @click="moveToCity(item)">
                {{ item.name }}
              </a>
            </div>
          </div>
          <div class="city_content_bottom">
            <el-scrollbar style="height: 100%">
              <div class="city_detail">
                <div v-for="(item, index) in PCList" :key="index">
                  <span @click="moveToCity(item)">{{ item.name }}:</span>
                  <p>
                    <a v-for="(v, i) in item.cities" :key="i" class="city-a" @click="moveToCity(v)">
                      {{ v.name }}
                    </a>
                  </p>
                </div>
              </div>
            </el-scrollbar>
          </div>
        </div>
        <el-button slot="reference" class="current-city">
          {{ currentCity }}
        </el-button>
      </el-popover>
      <div v-if="showRangePop" class="el-input-number--wrap is-controls-right el-input-number ml-16">
        <!-- <div class="el-input-number--wrap is-controls-right el-input-number ml-16"> -->
        <div class="el-input" style="width:120px;">
          <!-- <input ref="inputRef" type="number" class="el-input__inner" v-model="distance" :min="0.001" :max="1000" :step="0.001" @input="handleInputChange" /> -->
          <input ref="inputRef" type="number" class="el-input__inner" :value="distance" :min="0.001" :max="1000" :step="0.001" @input="handleInputChange" @blur="handleDistanceChange"
            @keydown.enter="handleDistanceChange" />
        </div>
        <div class="el-input-number--append">KM</div>
      </div>

      <!-- <div class="el-input-number--wrap ml-16">
        <el-input-number style="width:120px;" placeholder="" @keydown.enter.native="handleDistanceChange" @blur="handleDistanceChange" @change="handleInputChange" v-model="distance"
          controls-position="right" :min="0.001" :step="0.001" :max="1000" />
        <div class="el-input-number--append">KM</div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { jsonp } from "vue-jsonp";
import PCDList from "./PCDList.json";
var map,
  control,
  selectCircle,
  selectMarker,
  editor,
  district,
  geocoder,
  suggest;
// 设置圆形样式
const circleStyle = {
  color: "rgba(182,201,235,0.3)",
  showBorder: true,
  borderColor: "rgba(184,206,237,1)",
  borderWidth: 1,
};
const API_KEY = "KQBBZ-ND7CL-EMUPB-EERTS-I3NVJ-WCBTR";
export default {
  name: "TMap",
  props: {
    enterpriseListShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      address_detail: "",
      hide: false,
      visible: false,
      PCDList: PCDList, //[]
      flatMapList: [],
      hostCityList: [],
      PCList: [],
      currentCity: "上海市",
      active: 1,
      cityName: "",
      cityItem: null,
      movestart: false,
      oldPoint: null,
      showRangePop: false,
      distance: 0
    };
  },
  watch: {
    enterpriseListShow: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        if (val && this.oldPoint) {
          const width = Math.max(document.body.clientWidth - 1036 - 224, 0);
          const height = Math.max(document.body.clientHeight - 120, 0);
          const pixel = map.projectToContainer(this.oldPoint);
          const x = width / 2 - pixel.getX();
          const y = height / 2 - pixel.getY();
          map.setOffset({ x: x, y: y });
        } else if (!val && this.oldPoint) {
          map.setOffset({ x: 0, y: 0 });
        }
      },
    },
  },
  mounted() {
    if (this.$route.query.hide) this.hide = true;
    this.mapInit();
    document.addEventListener("keydown", this.handleKeyDown);
  },
  methods: {
    handleInputChange(val) {
      val = parseFloat(val.target.value);
      if (isNaN(val)) return;
      this.handleInputValue(val)
    },
    handleInputValue(val) {
      if (!val) return;
      val = val || 0.001;
      this.distance = val;
      const newRadius = val * 1000
      if (this.__oldCircle) {
        const geometries = this.__oldCircle.getGeometries();
        if (geometries.length > 0) {
          // 修改第一个圆的半径
          geometries[0].radius = newRadius;
          this.__oldCircle.setGeometries(geometries);
        }
      }

      // 更新搜索标记的圆圈半径
      if (selectCircle) {
        const geometries = selectCircle.getGeometries();
        if (geometries.length > 0) {
          // 修改第一个圆的半径
          geometries[0].radius = newRadius;
          selectCircle.setGeometries(geometries);
        }
      }
    },
    async handleDistanceChange(val) {
      const newValue = parseFloat(val.target.value);
      if (isNaN(newValue) || !newValue) {
        this.distance = 0
        this.$nextTick()
        this.handleInputValue(0.001)
      }
      const newRadius = this.distance * 1000
      if (this._oldNewRadius === newRadius) return
      const { center, site } = this.oldEchoData || {}
      this._oldNewRadius = newRadius
      this.handleEmitDetail(center, site, newRadius)
    },
    // 处理键盘事件
    handleKeyDown(event) {
      // 判断是否按下 ESC 键且当前处于绘制模式
      if (event.key === "Escape" && this.active === 2) {
        this.interruptDrawing();
      }
    },
    interruptDrawing() {
      this.showRangePop = false
    },
    //格式化省市区
    getPCD(province, city, district) {
      let str = province;
      if (province != city) str += city;
      if (city != district) str += district;
      return str;
    },
    //坐标转换
    LatLngTranslate(locations, type) {
      return new Promise((resolve, reject) => {
        const url = `https://apis.map.qq.com/ws/coord/v1/translate?locations=${locations}&type=${type}`;
        jsonp(url, {
          key: API_KEY,
          output: "jsonp",
        }).then((res) => {
          if (res.status == 0) {
            resolve(res.locations);
          } else {
            reject();
          }
        });
      });
    },
    async mapInit() {
      const that = this;
      // const data = await this.LatLngTranslate("31.236333,121.480193", 3);
      // let center = new TMap.LatLng(data[0].lat, data[0].lng);
      let center = new TMap.LatLng(31.230398, 121.473656);
      // 设置地图中心点坐标 设置地图缩放级别
      map = new TMap.Map("map-wrapper", { center: center, zoom: 12, });

      //设置鼠标在地图不同状态下的样式
      map.on("dragstart", function () {
        that.movestart = true;
        map.setCursorStyle("grabbing");
      });
      map.on("dragend", function () {
        map.setCursorStyle("grab");
      });
      this.changeActive(1);

      //将缩放控件放在左下角
      control = map.getControl(TMap.constants.DEFAULT_CONTROL_ID.ZOOM);
      control.setPosition(TMap.constants.CONTROL_POSITION.BOTTOM_LEFT);
      control.setClassName("custom-control");

      //新建一个行政区划类
      district = new TMap.service.District();
      //新建一个正逆地址解析类
      geocoder = new TMap.service.Geocoder();
      //新建一个关键词输入提示类
      suggest = new TMap.service.Suggestion({});

      //获取地图停止移动时的中心点经纬度
      map.on("moveend", function () {
        if (that.movestart) {
          const mapCenter = map.getCenter();
          that.getAddressByLatlng(mapCenter.lat, mapCenter.lng, "mapCenter");
        }
      });

      //地图停止缩放时获取中心点经纬度
      map.on("zoomend", function () {
        const mapCenter = map.getCenter();
        that.getAddressByLatlng(mapCenter.lat, mapCenter.lng, "mapCenter");
      });
      //获取省市区
      this.getDistrict();
    },
    //获取腾讯地图省市区
    getDistrict() {
      district.list().then((res) => {
        this.PCDList = res.result;
        this.formatPC();
      }).catch((err) => {
        this.$message.error(err.message);
      });
    },
    //格式化省市
    formatPC() {
      //二维数组扁平化，用于之后的城市搜索
      this.flatMapList = this.PCDList.flatMap((subArray) => subArray);
      //获取热门城市
      this.hostCityList = this.flatMapList.filter((v) =>
        ["北京", "上海", "广州", "深圳", "成都", "天津", "南京", "武汉", "杭州", "重庆"].includes(v.name)
      );
      //格式化省市
      const data = JSON.parse(JSON.stringify(this.PCDList));
      const provinceList = data[0];
      const cityList = data[1];
      for (let index = 0; index < provinceList.length; index++) {
        const item = provinceList[index];
        const p = splitId(item.id);
        item.cities = [];
        for (let i = 0; i < cityList.length; i++) {
          const v = cityList[i];
          const c = splitId(v.id);
          if (c == p) item.cities.push(v);
        }
      }
      function splitId(id) {
        return id.match(/.{1,2}/g)[0];
      }
      this.PCList = provinceList;
    },
    //选择城市，然后将地图中心移动到该城市
    moveToCity(city) {
      this.currentCity = city.fullname;
      this.movestart = false;
      this.changeActive(1);
      this.visible = false;
      const lat = city.location.lat;
      const lng = city.location.lng;
      //重置地图中心和缩放
      const center = new TMap.LatLng(lat, lng);
      map.setCenter(center);
      map.setZoom(12);
    },
    //移动地图时获取当前中心点的经纬度
    getAddressByLatlng(lat, lng, type) {
      return new Promise((resolve, reject) => {
        const location = new TMap.LatLng(lat, lng);
        //将给定的坐标位置转换为地址回显到当前城市
        geocoder.getAddress({ location: location }).then((res) => {
          if (type === "mapCenter") {
            const address_component = res.result.address_component;
            this.currentCity = address_component.city
              ? address_component.city
              : address_component.nation;
          }
          resolve(res.result.address);
        }).catch((err) => {
          this.$message.error(err.message);
          reject();
        });
      });
    },
    //根据输入的内容远程搜索相关城市
    querySearchCity(queryString, callback) {
      const list = this.flatMapList.filter((v) => v.fullname.includes(queryString) || v.pinyin?.join("").includes(queryString));
      callback(list);
    },
    //搜索城市
    handleSearchCity() {
      if (this.cityItem) {
        this.moveToCity(this.cityItem);
      } else {
        this.$message.warning("请输入正确的城市");
      }
    },
    //切换地图状态
    changeActive(v) {
      this.active = v;
      if (v === 1) this.handleDragMap();
      if (v === 2) this.handleDrawMap();
    },
    //拖动地图
    handleDragMap() {
      if (editor) editor.destroy();
      map.setDraggable(true);
      map.setCursorStyle("grab");
    },
    //圈范围
    handleDrawMap() {
      // this.clearSearchOverlays()
      this.drawerCircle();
      map.setDraggable(false);
      map.setCursorStyle("crosshair");
    },
    //绘制圆
    drawerCircle() {
      const that = this;
      this.address_detail = "";
      // 创建新的圆圈
      this.clearDrawerCircle();
      this.clearSearchOverlays();
      this.__oldCircle = new TMap.MultiCircle({ map, styles: { default: new TMap.CircleStyle(circleStyle) } });
      if (editor) {
        editor.destroy();
      }
      editor = new TMap.tools.GeometryEditor({
        map: map, // 编辑器绑定的地图对象
        overlayList: [{ overlay: this.__oldCircle, id: "circle", }],
        actionMode: TMap.tools.constants.EDITOR_ACTION.DRAW, // 编辑器的工作模式
        activeOverlayId: "circle", // 激活图层
        snappable: true, // 开启吸附
        selectable: true, // 开启点选，开启后可以点选图形进行修改和删除操作
      });
      // 监听绘制结束事件，获取绘制几何图形
      editor.on("draw_complete", async (geometry) => {
        const geometryList = editor.getOverlayList()[0].overlay.geometries;
        if (geometryList.length > 1) {
          //清除之前绘制的圆圈
          editor.setActionMode(TMap.tools.constants.EDITOR_ACTION.INTERACT);
          const id = geometryList[0].id;
          editor.select([id]);
          editor.delete();
          editor.setActionMode(TMap.tools.constants.EDITOR_ACTION.DRAW);
          //清除其他圆圈和标记
          that.clearSearchOverlays();
        }
        const latitude = geometry.center.lat;
        const longtitude = geometry.center.lng;
        const radius = geometry.radius;
        const addr = await that.getAddressByLatlng(latitude, longtitude);
        that.handleEmitDetail(geometry.center, addr, radius);
      });
      editor.on("draw_error", async (error) => {
        console.log('draw_error', error)
      })
    },
    //远程搜索
    querySearchAddress(queryString, callback) {
      suggest.getSuggestions({ keyword: queryString, location: map.getCenter() }).then((res) => {
        const list = res.data;
        callback(list);
      }).catch((err) => {
        this.$message.error(err.message);
      });
    },
    //下拉选择地点
    handleSelectAddress(item) {
      this.changeActive(1);
      const lat = item.location.lat;
      const lng = item.location.lng;
      const radius = 5000;
      this.getAddressByLatlng(lat, lng, "mapCenter");
      this.clearDrawerCircle();
      this.clearSearchOverlays()
      this.drawerCircleMarker(lat, lng, radius);
      this.handleEmitDetail(item.location, item.title, radius, false);
    },
    // 清除手动绘制的圆圈
    clearDrawerCircle() {
      if (this.__oldCircle) {
        this.showRangePop = false;
        this.__oldCircle.setMap(null);
        this.__oldCircle = null;
      }
    },
    // 清除搜索的标记和圆圈
    clearSearchOverlays() {
      // 清除之前的圆圈（如果有的话）
      if (selectCircle) {
        this.showRangePop = false;
        selectCircle.setMap(null)
        selectCircle = null
      };
      // 清除之前的标记（如果有的话）
      if (selectMarker) {
        this.showRangePop = false;
        selectMarker.setMap(null)
        selectMarker = null
      };
    },
    //选择搜索的地点并加标记和圆
    drawerCircleMarker(lat, lng, radius) {
      //重置地图中心和缩放
      const center = new TMap.LatLng(lat, lng);
      map.setCenter(center);
      map.setZoom(12);
      // 创建新的圆圈 
      selectCircle = new TMap.MultiCircle({
        map,
        styles: { default: new TMap.CircleStyle(circleStyle) },
        geometries: [{ styleId: "default", center: center, radius: radius }],
      });
      // 创建新的标记
      selectMarker = new TMap.MultiMarker({ map: map, geometries: [{ position: center, id: "marker" }], });
    },
    //获取当前范围的详情
    handleEmitDetail(center, site, distance, isEmit = true) {
      const latitude = center.lat;
      const longtitude = center.lng;
      this.distance = parseFloat((distance * 1.0 / 1000).toFixed(3));
      const data = { site, latitude, longtitude, distance, isEmit };
      this.oldPoint = new TMap.LatLng(data.latitude, data.longtitude);
      this.oldEchoData = { center, site };
      this.showRangePop = true;
      this.changeActive(1);
      this.$emit("detail", data);
      if (!isEmit) return this._oldNewRadius = null;
      this._oldNewRadius = this.distance * 1000;
    },
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.handleKeyDown);
    if (map) {
      map.destroy();
    }
  },
};
</script>

<style lang="scss" scoped>
.warpper {
  width: 100% !important;
  margin: 0 !important;
  height: calc(100vh - 144px);
  position: relative;
  display: flex;
  width: 100%;
  overflow: hidden;
}
.map-wrapper {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1;
  transition: right 0.8s ease-in-out;
}
.tools-bar {
  position: absolute;
  z-index: 2;
  padding-top: 32px;
  padding-left: 40px;
  display: flex;
}
::v-deep {
  .map-input {
    height: 36px;
    width: 300px;
    background: #ffffff;
    margin-left: 16px;
    border-radius: 4px;
    #suggestId {
      height: 36px;
      line-height: 36px !important;
      box-shadow: none;
      border: 1px solid #e8e8f0;
      border-radius: 4px;
      padding-left: 40px;
      box-sizing: border-box;
      &:focus,
      &:hover {
        border: 1px solid #e8e8f0;
      }
    }
  }
}
.current-city {
  padding: 0 10px;
  height: 36px;
  line-height: 36px;
  width: 168px;
  background: #fff;
  border: 1px solid #e8e8f0;
  margin-left: 16px;
  color: #bfbfbf;
  text-align: left;
  &:hover {
    color: #3d6dcc;
  }
}
.city-list-container {
  height: 100%;
  .ct_title {
    height: 42px;
    line-height: 42px;
    background: #fbfbfb;
    border-radius: 4px 4px 0px 0px;
    font-weight: 400;
    color: #333333;
    font-size: 14px;
    padding-left: 24px;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(151, 151, 151, 0.2);
    .el-icon-close {
      float: right;
      margin-top: 12px;
      margin-right: 24px;
      font-size: 16px;
      cursor: pointer;
    }
  }
  .city_content_top,
  .city_content_medium {
    margin: 0 24px;
    padding: 16px 0;
    line-height: 20px;
    border-bottom: 1px solid rgba(151, 151, 151, 0.2);
  }
  .city_content_top {
    display: flex;
    align-items: center;
    .cur_city_info {
      color: #333333;
      font-size: 14px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding-right: 10px;
    }
    .el-autocomplete {
      width: 200px;
      margin-right: 10px;
      margin-left: auto;
    }
    .el-button {
      border-color: #e8e8f0;
      &:hover {
        border-color: #5088ff;
      }
    }
  }
  .city-a {
    color: #5088ff;
    margin-right: 12px;
    font-size: 14px;
    display: inline-block;
    line-height: 20px;
    &:hover {
      text-decoration: underline;
    }
  }
  .city_content_bottom {
    height: calc(100% - 162px);
    .city_detail {
      padding: 24px 24px 0;
      div {
        display: flex;
        margin-bottom: 10px;
      }
      span {
        color: #5088ff;
        font-size: 16px;
        font-weight: bold;
        display: block;
        width: 66px;
        text-align: left;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
      p {
        width: calc(100% - 66px);
        a {
          margin-bottom: 6px;
        }
      }
    }
  }
}
.select-tabs {
  display: flex;
  span {
    display: block;
    height: 36px;
    cursor: pointer;
  }
  .drag {
    background-image: url("~@/assets/gbIcon/dt_01.png");
    width: 100px;
    &.dragActive {
      background-image: url("~@/assets/gbIcon/dt_001.png");
      width: 100px;
    }
  }
  .draw {
    background-image: url("~@/assets/gbIcon/dt_002.png");
    width: 86px;
    &.drawActive {
      background-image: url("~@/assets/gbIcon/dt_02.png");
      width: 86px;
    }
  }
}

.el-input-number--wrap {
  display: flex;
  position: relative;
  width: auto !important;
  /* 隐藏 input[type="number"] 的上下箭头 */
  input[type="number"] {
    -webkit-appearance: none; /* WebKit 浏览器 */
    -moz-appearance: textfield; /* Firefox */
    appearance: none; /* 标准属性 */
  }

  /* 针对 WebKit 内核浏览器进一步隐藏箭头 */
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* 针对 IE/Edge */
  input[type="number"] {
    -ms-clear: none;
    -ms-reveal: none;
  }
  .el-input-number--append {
    position: absolute;
    z-index: 1;
    right: 0;
    width: 34px;
    height: 36px;
    line-height: 36px;
    text-align: center;
  }
}
</style>

<style lang="scss">
.custom-city-popper {
  margin-top: 0 !important;
  box-shadow: none !important;
  padding: 0 !important;
  height: 500px !important;
}
.custom-control .tmap-zoom-control {
  margin-left: 10px;
  width: 30px;
  height: 61px;
  cursor: pointer;
  .tmap-zoom-in,
  .tmap-zoom-out {
    width: 30px;
    height: 30px;
    left: 0;
    img {
      width: 20px;
      height: 20px;
      margin-left: 6px;
      margin-top: 6px;
    }
    &:hover {
      background-color: #f2f2f2;
    }
  }
  .tmap-zoom-in {
    top: 0;
  }
  .tmap-zoom-out {
    top: 31px;
  }
}
#suggestId {
  background: url("~@/assets/gbIcon/search_icon.png") no-repeat;
  background-position-y: center;
  background-position-x: 12px;
}
#suggestId::-webkit-input-placeholder {
  color: #bfbfbf;
  font-weight: 400;
  font-size: 14px;
}
#suggestId::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #bfbfbf;
  font-weight: 400;
  font-size: 14px;
}
#suggestId:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #bfbfbf;
  font-weight: 400;
  font-size: 14px;
}
#suggestId:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #bfbfbf;
  font-weight: 400;
  font-size: 14px;
}
</style>
